// extracted by mini-css-extract-plugin
export var linkButton = "LinkCardV1-module--linkButton--j62xg";
export var linkCard = "LinkCardV1-module--linkCard--7OLoJ";
export var linkCardIcon = "LinkCardV1-module--linkCardIcon--Pnkia";
export var linkCardTitle = "LinkCardV1-module--linkCardTitle--0SZPr";
export var customLinkIcon = "LinkCardV1-module--customLinkIcon--C2zLn";